import { render, staticRenderFns } from "./PageLoading.vue?vue&type=template&id=d45b0720&scoped=true"
import script from "./PageLoading.vue?vue&type=script&lang=js"
export * from "./PageLoading.vue?vue&type=script&lang=js"
import style0 from "./PageLoading.vue?vue&type=style&index=0&id=d45b0720&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45b0720",
  null
  
)

export default component.exports